module.exports = __webpack_public_path__ + "static/media/ios-arrow-up.7a0ca932.svg";